import { waLink } from "@/constants/content";
import { scrollToSection } from "@/hooks/useLenis";

const DEFAULT_MSG =
  "Hi, I'm interested in Central Plaza / Central Heights at Sector 10A, Kharkhoda. Please share more details.";

export const LeadCTAs = ({
  className = "",
  enquireLabel = "Enquire Now",
  whatsappLabel = "WhatsApp",
  theme = "light",
  enquireTestId,
  waTestId,
  message = DEFAULT_MSG,
}) => {
  const enquire = () => scrollToSection("#enquire");
  const waClass = theme === "dark" ? "btn btn-outline-light" : "btn btn-outline-dark";
  const stack = theme === "stack";

  return (
    <div className={`cp-lead-ctas ${stack ? "cp-lead-ctas--stack" : ""} ${className}`.trim()}>
      <button type="button" className="btn btn-gold" onClick={enquire} data-testid={enquireTestId}>
        {enquireLabel}
      </button>
      <a
        href={waLink(message)}
        target="_blank"
        rel="noreferrer"
        className={waClass}
        data-testid={waTestId}
      >
        {whatsappLabel}
      </a>
    </div>
  );
};
